'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _Object$getOwnPropertyDescriptor = require('@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor');
var _Object$defineProperty = require('@babel/runtime-corejs3/core-js-stable/object/define-property');
var _Object$create = require('@babel/runtime-corejs3/core-js-stable/object/create');
var _Object$getPrototypeOf = require('@babel/runtime-corejs3/core-js-stable/object/get-prototype-of');
var _Object$setPrototypeOf = require('@babel/runtime-corejs3/core-js-stable/object/set-prototype-of');
var _Date$now = require('@babel/runtime-corejs3/core-js-stable/date/now');
var globalThis = require('@tanker/global-this');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _Object$getOwnPropertyDescriptor__default = /*#__PURE__*/_interopDefaultLegacy(_Object$getOwnPropertyDescriptor);
var _Object$defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_Object$defineProperty);
var _Object$create__default = /*#__PURE__*/_interopDefaultLegacy(_Object$create);
var _Object$getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_Object$getPrototypeOf);
var _Object$setPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_Object$setPrototypeOf);
var _Date$now__default = /*#__PURE__*/_interopDefaultLegacy(_Date$now);
var globalThis__default = /*#__PURE__*/_interopDefaultLegacy(globalThis);

var File = globalThis__default['default'].File; // By default, suppose File doesn't need to be ponyfilled

var FilePonyfill = File;

try {
  // Only try and ponyfill if a previous File class exists (i.e. skip Node.js)
  if (File !== undefined) {
    new File([], '');
  }
} catch (e) {
  // Create a File ponyfill with a working constructor and an ancestry
  // that will look like this: FilePonyfill < File < Blob
  FilePonyfill = function FilePonyfill(chunks, name, opts) {
    var blob = new Blob(chunks, opts || {});
    blob.name = name;
    blob.lastModified = opts && opts.lastModified || _Date$now__default['default']();
    blob.lastModifiedDate = new Date(blob.lastModified);

    _Object$setPrototypeOf__default['default'](blob, _Object$getPrototypeOf__default['default'](this));

    return blob;
  };

  var proto = _Object$create__default['default'](File.prototype);

  _Object$defineProperty__default['default'](proto, 'size', _Object$getOwnPropertyDescriptor__default['default'](Blob.prototype, 'size'));

  _Object$defineProperty__default['default'](proto, 'type', _Object$getOwnPropertyDescriptor__default['default'](Blob.prototype, 'type'));

  proto.slice = _sliceInstanceProperty__default['default'](Blob.prototype) || Blob.prototype.mozSlice || Blob.prototype.webkitSlice;
  proto.constructor = FilePonyfill;
  FilePonyfill.prototype = proto;
}

var FilePonyfill$1 = FilePonyfill;

exports.default = FilePonyfill$1;
